import React from "react";
import Main from "../../components/layout/Main";
import { CameraDevices } from "../Camera";

// Camera tab (app/screens/cam/CamView.js), for homes without Automation.
function Camera() {
  return (
    <Main header="tab" title="Camera">
      <CameraDevices />
    </Main>
  );
}

export default Camera;
